import type { FC, ReactNode } from "react";
import { Popover, type PopoverProps } from "react-aria-components";
import { menuStyle } from "./menuStyle.js";

/** Maximum height for menus expected to contain long option lists. */
export const longMenuMaxHeight = 480;

export interface SimpleMenuPopoverProps extends Omit<
  PopoverProps,
  "className"
> {
  children: ReactNode;
  /** Optional className applied to the Popover. Use to override the menu width. */
  className?: string;
}

export const SimpleMenuPopover: FC<SimpleMenuPopoverProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <Popover className={menuStyle().popover({ className })} {...props}>
      <div className={menuStyle().scrollContainer()}>{children}</div>
    </Popover>
  );
};
